import { client } from 'api/baseApi.ts';
import { IntermediateMediaFormatter } from 'core/formatters/IntermediateMediaFormatter.ts';

export const getStudioMusicVideoSceneService = async (mediaId, queryParams, request) => {
	return client.studio.generateMusicVideoScenes(mediaId, queryParams, request);
};

export const getStudioMusicVideoSceneDataService = async (mediaId, queryParams) => {
	const feedItemsResponse = await client.studio.getMusicVideoSceneData(mediaId, queryParams);
	const { data } = feedItemsResponse;
	return new IntermediateMediaFormatter().getMusicVideoSceneDataItems(data);
};

export const getCanvasMusicVideoSceneService = async (mediaId, queryParams, request) => {
	return client.canvas.generateMusicVideoScenes(mediaId, queryParams, request);
};

export const getCanvasMusicVideoSceneDataService = async (mediaId, queryParams) => {
	const feedItemsResponse = await client.canvas.getMusicVideoSceneData(mediaId, queryParams);
	const { data } = feedItemsResponse;
	return new IntermediateMediaFormatter().getMusicVideoSceneDataItems(data);
};
